import { api } from '~/api';
import type { Filter, PaginatedResponse, Sort } from '~/search';
import type { User } from '~/types/domain';

const defaultPerPage = 25;
export const defaultSort: Sort[] = [{ field: 'created_at', order: 'DESC' }];

export async function searchTable<T>({
    table,
    page = 1,
    filters,
    perPage = defaultPerPage,
    sort = defaultSort,
}: {
    table: string;
    page?: number;
    filters: Filter[];
    perPage?: number;
    sort?: Sort[];
}) {
    return await api<PaginatedResponse<T>>(`/admin/backoffice/${table}/search`, {
        method: 'POST',
        body: {
            page,
            per_page: perPage,
            filters,
            sort,
        },
    });
}

export function getSingle<T = unknown>(table: string, id: number): Promise<T> {
    return api<T>(`/admin/backoffice/${table}/${id}`);
}

export async function getCustomerNames(ids: number[]): Promise<Partial<Record<number, string>>> {
    const resp = await searchTable<{ id: number; company_name: string }>({
        table: 'customers',
        perPage: ids.length,
        filters: ids.map((i) => ({ type: 'OR', field: 'id', operator: 'equals', value: i })),
    });

    const result: Partial<Record<number, string>> = {};
    for (const c of resp.rows || []) {
        result[c.id] = c.company_name;
    }
    return result;
}

export async function getUsers(ids: number[], options?: { perPage?: number }): Promise<User[]> {
    const data = await searchTable<User>({
        table: 'users',
        page: 1,
        perPage: options?.perPage,
        filters: [
            {
                type: 'AND',
                field: 'id',
                operator: 'any',
                value: ids,
            },
        ],
    });

    return data.rows || [];
}
